import { CircularProgress, createStyles, makeStyles, Paper } from '@material-ui/core';
import React from 'react';
import { THUMBNAIL_NAME, THUMBNAIL_PADDING } from "../components/index.js";
import { usePreviewImage, useViewerState } from "../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    thumbnailPage: {
      padding: 0,
      overflow: 'hidden',
      width: ({
        page
      }) => page.Width - 2 * THUMBNAIL_PADDING,
      height: ({
        page
      }) => page.Height - 2 * THUMBNAIL_PADDING,
      position: 'relative'
    },
    image: {
      display: 'flex',
      justifyContent: 'center'
    }
  });
});

/**
 * Defined the component's own properties
 */

export const ThumbnailPage = props => {
  const classes = useStyles(props);
  const viewerState = useViewerState();
  const page = usePreviewImage(props.page.Index);
  const isActive = page.image && viewerState.activePage === page.image.Index;
  const imgUrl = page.image && page.image.ThumbnailImageUrl || '';
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: isActive ? 8 : 2,
    className: THUMBNAIL_NAME,
    style: {
      margin: THUMBNAIL_PADDING
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.thumbnailPage,
    onClick: ev => {
      props.onClick(ev);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.image
  }, imgUrl ? /*#__PURE__*/React.createElement("img", {
    src: `${imgUrl}${viewerState.showWatermark ? '?watermark=true' : ''}`,
    alt: "",
    style: {
      transition: 'transform .1s ease-in-out'
    }
  }) : /*#__PURE__*/React.createElement(CircularProgress, {
    style: {
      marginTop: '50%'
    }
  }))));
};
//# sourceMappingURL=thumbnail-page.js.map